import React from "react";

type Props = React.PropsWithChildren;

const Page: React.FC<Props> = ({ children }) => {
    return (
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: 'rgb(32, 32, 32)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start'
      }}>
        {children}
      </div>
    );
}

export default Page;